import React, {useEffect, useState} from 'react';
import './StatusOrderView.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import {Container, Form, Button, Row, Col, Image} from 'react-bootstrap';
import {LogoFacebook, LogoInstagram, LogoTwitter} from "@carbon/icons-react";
import iconoFooter from "../logoFooter.svg";
import { useNavigate, useLocation } from 'react-router-dom';
import {getShopBranchIdFromToken, getShopIdFromToken} from "../auth/authUtils";

export default function StatusOrderView() {
    const navigate = useNavigate();
    const location = useLocation();
    const shopBranch = location.state?.shopBranch;
    const[isViewCredentialsOrder, setIsViewCredentialsOrder] = useState(true);

    const [orderLogsStatus, setOrderLogsStatus] = useState([]);
    const [order, setOrder] = useState([]);

    const [orderNumber, setOrderNumber] = useState('');
    const [orderOwner, setOrderOwner] = useState('');

    const [imageSrc, setImageSrc] = useState('');
    const [colorshopBranch, setColorshopBranch] = useState('#000000');
    const [nameShopBranch, setNameShopBranch] = useState('');

    const [instagram, setInstagram] = useState('');
    const [facebook, setFacebook] = useState('');
    const [twitter, setTwitter] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsViewCredentialsOrder(false);
        getDetailsOrder(orderNumber, orderOwner, shopBranch.id);
    };

    useEffect(() => {
        document.title = 'QReate - Estado del pedido';
        if (!shopBranch) {
            // Redirige a la página anterior
            navigate(-1); // o podrías usar navigate('/') para ir al inicio
        }
        setNameShopBranch(shopBranch.name);
        getCategoryColor();
        getLogoImage();
        getRedes()
    }, []);


    const getDetailsOrder = (orderNumber, ownerOrder, shopBranchId) => {
        axios.get(process.env.REACT_APP_API_ORDER_VIEW_STATUS_ROUTE.replace(":orderNumber", orderNumber.trim()).replace(":ownerOrder", ownerOrder.trim()).replace(":shopBranchId", shopBranchId))
            .then(response => {
                setOrder(response.data);
                setOrderLogsStatus(response.data.orderStatusLogs);

            })
            .catch((r) => {
                dontExistOrder();
            })
    }

    const dontExistOrder = () =>{
        setIsViewCredentialsOrder(true);
        Swal.fire({
            title: 'Upsss',
            text: 'No se encontró un pedido con estos datos.',
            icon: 'error',
            showConfirmButton: true,
            confirmButtonText: 'Cerrar'
        });
    }

    function alertError(){
        Swal.fire({
            title: 'Upsss',
            text: 'Ocurrió un error, vuelve a intentar',
            icon: 'error',
            timer: 1500,
            showConfirmButton: false,
        });
    }

    const getStatus = (status) => {
        switch (status){
            case "RECEIVED" : return "Recibido";
            case "IN_PREPARATION" : return "En preparacion";
            case "DELIVERY_IN_PROGRESS" : return "En camino";
            case "FINALIZED" : return "Finalizado";
            case "CANCELLED" : return "Cancelado";
            default: return "Editado"
        }
    }

    const getCategoryColor = () => {
        axios.get(process.env.REACT_APP_API_SHOP_ROUTE_UPDATE_CATEGORY_COLOR + "/" + shopBranch.id)
            .then((response) => {
                setColorshopBranch(response.data);
            })
            .catch((error) => {
                console.error(error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo cargar el color de la categoría',
                });
            });
    }

    const getLogoImage = () => {
        // Obtener Logo de catálogo Carta
        axios.get(process.env.REACT_APP_API_SHOP_ROUTE_UPDATE_LOGO_IMAGE + "/" + shopBranch.id, {
            responseType: "blob",
        })
            .then((response) => {
                if(response.data.size !== 0){
                    const imageBlob = response.data;
                    const imageURL = URL.createObjectURL(imageBlob);
                    setImageSrc(imageURL);
                }
            })
            .catch(() => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error cargando la imagen del logo',
                })
            })
    }

    const getValueRedInstagram = (redes) => {
        let instagram = redes && redes.find(red => red.socialMediaType === "INSTAGRAM");
        if(instagram != null){
            setInstagram(instagram.socialMediaLink);
        }
    }

    const getValueRedFacebook = (redes) =>{
        let facebook = redes && redes.find(red => red.socialMediaType === "FACEBOOK");
        if(facebook != null){
            setFacebook(facebook.socialMediaLink);
        }
    }

    const getValueRedTwitter = (redes) =>{
        let twitter = redes && redes.find(red => red.socialMediaType === "TWITTER");
        if(twitter != null){
            setTwitter(twitter.socialMediaLink);
        }
    }

    const getRedes = () => {
        axios.get(process.env.REACT_APP_API_SOCIALMEDIA_ROUTE, {
            withCredentials: true,
            params: {
                status: true,
            }
        })
            .then(response => {
                getValueRedInstagram(response.data);
                getValueRedFacebook(response.data);
                getValueRedTwitter(response.data);
            })
    }

    function formatPrice(price) {
        if (!price) return ''; // Manejar caso de valor vacío
        const parts = price.toString().split('.'); // Separar parte entera de la decimal
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Agregar separador de miles
        return parts.join(','); // Unir las partes con coma como separador decimal
    }

    const goBackToMenu = () => {
        navigate(-1);
    };

    return (
       <div className="containerViewStatusOrder notranslate" translate="no">
        <div className="viewStatusOrder">
            {imageSrc != null && imageSrc != '' ? (
                <div className="banner bannerStatusOrder"
                           style={{
                               backgroundColor: colorshopBranch,
                               display: "flex",
                               justifyContent: "center",
                               alignItems: "center"
                           }}>
                    <Image src={imageSrc} alt="QReate" className='imgCartaBanner'/>
                </div>
            ) : (
                <Container className="banner bannerStatusOrder"
                           style={{
                               backgroundColor: colorshopBranch,
                               display: "flex",
                               justifyContent: "center",
                               alignItems: "center"
                           }}>
                    <h1 className='nameShopCarta'>{nameShopBranch}</h1>
                </Container>
            )}
            {isViewCredentialsOrder ?
                (
                    <>
                        <div className="orderSearchContainer">
                            <h1 className="orderSearchTitle">Ver mi pedido</h1>
                            <p className="orderSearchComment">
                                Conoce el estado de tu pedido y todos sus detalles en esta sección.
                            </p>
                            <Row className="justify-content-center">
                                <Col xs={12} md={6}>
                                    <Form onSubmit={handleSubmit} className="orderSearchForm shadow p-4 rounded">
                                        <Form.Group controlId="orderNumber" className="mb-3">
                                            <Form.Label><strong>Número de Pedido</strong></Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Ingrese el número de pedido"
                                                value={orderNumber}
                                                onChange={(e) => setOrderNumber(e.target.value)}
                                                required
                                            />
                                        </Form.Group>

                                        <Form.Group controlId="orderOwner" className="mb-4">
                                            <Form.Label><strong>Nombre del Titular</strong></Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Ingrese el nombre del titular del pedido"
                                                value={orderOwner}
                                                onChange={(e) => setOrderOwner(e.target.value)}
                                                required
                                            />
                                        </Form.Group>

                                        <div className="d-flex justify-content-between">
                                            <button type="button" className="btn btn-outline-secondary backButton" onClick={goBackToMenu}>
                                                Volver a Carta
                                            </button>

                                            <button type="submit" className="btn btn-primary consultButton">
                                                Ver Pedido
                                            </button>
                                        </div>
                                    </Form>
                                </Col>
                            </Row>
                        </div>
                    </>
                ) :
                (
                    <>
                        <div className="orderInfoBox">
                            <h1 className="orderStatusTitle">
                                <div className="orderInfo">
                                    <span className="orderLabel">Número pedido:</span>
                                    <span className="orderNumber">{orderNumber}</span>
                                </div>
                                <div className="orderInfo">
                                    <span className="orderLabel">Titular:</span>
                                    <span className="orderOwner">{orderOwner}</span>
                                </div>
                            </h1>
                        </div>
                        <div className="orderLogTimeline">
                            {orderLogsStatus.map(log => (
                                <div className="orderLogRowStatusOrder" key={log.id}>
                                    <div className="timelineDot"></div>
                                    <div className="orderLogContent">
                                        <div className="orderLogStatus">{getStatus(log.status)}</div>
                                        <div className="orderLogDate">{log.dateStatus}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="orderDetailsContainer">
                            <h2 className="orderDetailsTitle">Detalles del Pedido</h2>
                            <div className="orderDetailsRow">
                                <span className="orderDetailsLabel">Fecha del pedido:</span>
                                <span className="orderDetailsValue">{order.orderDate}</span>
                            </div>
                            <div className="orderDetailsRow">
                                <span className="orderDetailsLabel">Tipo de entrega:</span>
                                <span
                                    className="orderDetailsValue">{order.delivery ? 'A domicilio' : 'Retiro por el local'}</span>
                            </div>
                            {order.delivery &&
                                <>
                                    <div className="orderDetailsRow">
                                        <span className="orderDetailsLabel">Precio de envio:</span>
                                        <span
                                            className="orderDetailsValue">${formatPrice(order.amountDelivery)} (Incluído en el total)</span>
                                    </div>
                                    <div className="orderDetailsRow">
                                        <div className="orderDetailsObservation">
                                            {order.deliveryObservation}
                                        </div>
                                    </div>
                                </>
                            }
                            <div className="orderDetailsRow">
                                <span className="orderDetailsLabel">Observación del pedido:</span>
                            </div>
                            <div className="orderDetailsRow">
                                <div className="orderDetailsObservation">
                                    {order.orderObservation}
                                </div>
                            </div>
                            <div className="orderDetailsRow">
                                <span className="orderDetailsLabel">PRECIO TOTAL:</span>
                                <span className="orderDetailsValue">${formatPrice(order.totalAmount + order.amountDelivery)}</span>
                            </div>

                            <hr className="sectionDivider"/>

                            <h3 className="orderProductsTitle">Productos por categoría</h3>
                            {order.orderDetails && Object.entries(order.orderDetails.reduce((acc, detail) => {
                                if (!acc[detail.categoryName]) {
                                    acc[detail.categoryName] = [];
                                }
                                acc[detail.categoryName].push(detail);
                                return acc;
                            }, {})).map(([categoryName, details]) => (
                                <div key={categoryName} className="categoryGroup">
                                    <h4 className="categoryName">{categoryName}</h4>
                                    {details.map((detail) => (
                                        <div key={detail.id} className="productDetail">
                                            <div className="productName">{detail.productName}</div>
                                            <div className="productInfo">
                                                <span className="productQuantity">Cantidad: {detail.quantity}</span>
                                                <span
                                                    className="productPrice">Precio Unitario: ${formatPrice(detail.unitaryPrice)}</span>
                                                <span
                                                    className="productSubtotal">Subtotal: ${formatPrice(detail.subTotal)}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                        <button className="btn volverButton m-4" onClick={() => goBackToMenu()}>
                            Volver
                        </button>
                    </>
                )
            }

            <footer className='footer-status-order' style={{
                backgroundColor: colorshopBranch,
                padding: '20px 0',
                bottom: '0',
                width: '100%'
            }}>
                <Container>
                    <Row className="text-center">
                        <Col>
                            <img src={iconoFooter} alt="Icono" />
                        </Col>
                    </Row>
                </Container>
            </footer>
        </div>
     </div>                           
    );
}